export enum SubscriptionInvoiceStatus {
    Deleted = 'deleted',
    Draft = 'draft',
    Open = 'open',
    Paid = 'paid',
    Uncollectible = 'uncollectible',
    Void = 'void',
}
